import {Component, OnDestroy, OnInit, ViewChild, Output, Input, EventEmitter} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
// removed legacy rxjs-compat operator import
import {PaginationInstance} from "ngx-pagination";
import {UserVerificationService} from "../services/user-verification.service";
import {KeycloakService} from "../services/keycloak.service";
import { Subscription } from 'rxjs';
import {NgForm} from "@angular/forms";
import {HttpService} from "../services/http.service";
import {ApiEndpoints} from "../services/api-endpoints";
import {flatMap, map, tap} from 'rxjs/operators';

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-roaming-community-members',
  templateUrl: './roaming-community-members.component.html',
})
export class RoamingCommunityMembersComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  username: string = KeycloakService.username;
  listInfo: Object;

  listCommunityMembers: any[];
  canAddCommunityMember: boolean;

  public createRCM = true;
  public inputKeywordCommunityMemberSearch = "";
  public optionCommunityMemberSearch = "Search Type";

  public communityMembersRefreshing = false;

  isAdminSubscription: Subscription;
  httpSubscription: Subscription;

  configPagerCommunityMembers: PaginationInstance = {
    id: 'community-members-list',
    currentPage: 1,
    itemsPerPage: 5,
  };

  @Input() virtId: string;
  @Input() name: string;
  @Input() protocolVersion: string;
  @Output() communityMembersLoadedEvent = new EventEmitter<any[]>();

  constructor(private route: ActivatedRoute,
           private router: Router,
           private http: HttpClient,
           private userVerificationService: UserVerificationService,
           private httpService: HttpService) {
    this.isAdmin = this.userVerificationService.isAdmin;
  }

  editCommunityMember(netAid, netBid, name, partnerName, id, partnerId) {
    this.router.navigate(['./edit-roaming-community-member'], {
      queryParams: {
        netAid,
        netBid,
        name,
        partnerName,
        id,
        partnerId
      }
    });
  }

  createCommunityMembershipPage(name, rcId, protocolVersion, title) {
    this.router.navigate(['./create-roaming-community-member'], {queryParams: {name, rcId, protocolVersion, title}});
  }

  //get Roaming CommunityMember widget
  CommunityMembers(id) {
    var body: any = {"virtId": id};
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let options =  {headers: headers};
    var url = ApiEndpoints.GET_ROAMING_COMMUNITY_MEMBERS;
    this.communityMembersRefreshing = true;
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.listCommunityMembers = data;
          this.communityMembersLoadedEvent.emit(this.listCommunityMembers);
          this.communityMembersRefreshing = false;
        }
      );
  }

  //Community Members search func
  CommunityMembersSearch(vIdSearch, urlSearch, filterSearch, keywordSearch) {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let options =  {headers: headers};
    if (filterSearch == "Name") {
      var body: any = {"virtId": vIdSearch, "name": keywordSearch};
      var url = urlSearch;
      this.communityMembersRefreshing = true;
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listCommunityMembers = data;
            this.communityMembersLoadedEvent.emit(this.listCommunityMembers);
            this.communityMembersRefreshing = false;
          }
        );
    }
    if (filterSearch == "NetID") {
      var body: any = {"virtId": vIdSearch, "netId": keywordSearch};
      var url = urlSearch;
      this.communityMembersRefreshing = true;
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.listCommunityMembers = data;
            this.communityMembersLoadedEvent.emit(this.listCommunityMembers);
            this.communityMembersRefreshing = false;
          }
        );
    }
    if (filterSearch == 'Search Type') {
        this.CommunityMembers(this.virtId)
    }
  }

  getAllNetworkServerNotInCommunity(virtId, protocolVersion) {
    var url = ApiEndpoints.GET_ALL_NETWORK_SERVERS_NO_IRC;
    var body = {
      "virtID" : virtId,
      "protocolVersion": protocolVersion
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};

    this.http.post<Array<any>>(url, body, options).subscribe(
        data => {
          this.canAddCommunityMember = data.length != 0;
        }
      );
  }

  refreshCommunityMembers() {
    var urlSearch = ApiEndpoints.GET_ROAMING_COMMUNITY_MEMBERS;
    this.CommunityMembersSearch(this.virtId, urlSearch, this.optionCommunityMemberSearch, this.inputKeywordCommunityMemberSearch);
  }

  onKeywordSearch(event: KeyboardEvent) {
    var urlSearch = ApiEndpoints.GET_ROAMING_COMMUNITY_MEMBERS;
    if (event.keyCode === 13) {
      this.CommunityMembersSearch(this.virtId, urlSearch, this.optionCommunityMemberSearch, this.inputKeywordCommunityMemberSearch);
    }
  }

  onOptionCommunityMemberSearchChanged(event) {
    const value = event.target.value;
    this.inputKeywordCommunityMemberSearch = "";
  }

  ngOnInit() {
    this.CommunityMembers(this.virtId);
    this.getAllNetworkServerNotInCommunity(this.virtId, this.protocolVersion);

    $('.table-filter-search').selectpicker({
      liveSearch: true,
      maxOptions: 1
    });
  }

  ngOnDestroy() {

  }
}
